import { createBrowserRouter, type RouteObject } from "react-router-dom"
import { AuthLayout } from "../layouts/AuthLayout"
import { MainLayout } from "../layouts/MainLayout"
import { authRoutes } from "../../features/auth/routes"
import { dashboardRoutes } from "../../features/dashboard/routes"
import { aziendeRoutes } from "../../features/aziende/routes"
import { referentiRoutes } from "../../features/referenti/routes"
import { screeningRoutes } from "../../features/screening/routes"
import { contenutiRoutes } from "../../features/contenuti/routes"
import { exportRoutes } from "../../features/export/routes"
import { supportoRoutes } from "../../features/supporto/routes"
// import { impostazioniRoutes } from "../../features/impostazioni/routes"
import NotFoundPage from "../../features/misc/not-found/NotFoundPage"
import { profiloRoutes } from "@/features/profile/routes"
import { statisticheRoutes } from "@/features/stats/routes"

const adminRoutes: RouteObject[] = [
  ...dashboardRoutes,
  ...aziendeRoutes,
  ...referentiRoutes,
  ...screeningRoutes,
  ...contenutiRoutes,
  ...exportRoutes,
  ...supportoRoutes,
  // ...impostazioniRoutes,
  ...profiloRoutes,
  ...statisticheRoutes,
  {
    path: '*',
    element: <NotFoundPage />,
  },
]

export const router = createBrowserRouter([
  {
    element: <AuthLayout />,
    children: authRoutes,
  },
  {
    element: <MainLayout />,
    children: adminRoutes,
  },
])
